module.exports = __webpack_public_path__ + "img/img52.5e7e2251.png";